// todo: unset stuff has not been called anywhere. Scope it out!
const root = {
  state: {
    activeTour: 0,
    showFreshdeskWidget: true,
    fileDownloadNotification: false
  },
  getters: {
    getActiveTour: (state) => state.activeTour,
    getFreshdeskFlag: (state) => state.showFreshdeskWidget
  },
  mutations: {
    SET_TOUR_STATE: (state, data) => {
      state.activeTour = data ? state.activeTour + 1 : state.activeTour - 1
    },
    RESET_TOUR_STATE: (state) => {
      state.activeTour = 0
    },
    SET_FRESHDESK_WIDGET: (state) => {
      state.showFreshdeskWidget = true
    },
    RESET_FRESHDESK_WIDGET: (state) => {
      state.showFreshdeskWidget = false
    },
    SET_DOWNLOAD_NOTIFICATION: (state, data) => {
      state.fileDownloadNotification = data.fileDownloadNotification
    }
  },
  actions: {
    setTourState({ commit }, data) {
      commit('SET_TOUR_STATE', data)
    },
    resetTourState({ commit }) {
      commit('RESET_TOUR_STATE')
    },
    setFreshdeskWidget({ commit }) {
      commit('SET_FRESHDESK_WIDGET')
    },
    resetFreshdeskWidget({ commit }) {
      commit('RESET_FRESHDESK_WIDGET')
    },
    setDownloadNotification({ commit }, data) {
      commit('SET_DOWNLOAD_NOTIFICATION', data)
    }
  }
}

export default root
